<template>
  <div class="footer">
    <!-- Aba Traçado: todos os botões -->
    <template v-if="activeTab === 'tracado'">
      <md-button
        :title="$t('x_plus.select_attachments')"
        class="btn-anexar-arquivos"
        @click="$emit('anexar-arquivos')"
      >
        <span class="material-icons" style="color: #fff">attach_file</span>
      </md-button>
      <md-button
        :title="$t('x_plus.view_exam')"
        style="color: #fff"
        class="btn-primary"
        @click="$emit('visualizar-exame')"
      >
        <span class="material-icons">visibility</span>
      </md-button>
      <div class="separator"></div>
      <md-button class="md-raised" @click="$emit('close')">{{ $t('x_plus.cancel') }}</md-button>
      <md-button
        :disabled="examStatus !== constants.DICOM_PLUS_STATUS.PENDENTE"
        class="btn-primary btn-save"
        style="color: #fff"
        type="submit"
        @click="$emit('save')"
        >{{ $t('x_plus.save') }}</md-button
      >
    </template>

    <!-- Aba Paciente e Complementares: fechar, salvar -->
    <template v-else>
      <md-button class="md-raised" @click="$emit('close')">{{ $t('x_plus.cancel') }}</md-button>
      <md-button
        :disabled="examStatus !== constants.DICOM_PLUS_STATUS.PENDENTE"
        class="btn-primary btn-save"
        style="color: #fff"
        type="submit"
        @click="$emit('save')"
        >{{ $t('x_plus.save') }}</md-button
      >
    </template>
  </div>
</template>

<script>
  import constants from '@/shared/constants/constants'
  export default {
    name: 'XPlusModalFooter',
    props: {
      activeTab: { type: String, required: true },
      examStatus: { type: Number, required: true },
      attachedFilesCount: { type: Number, default: 0 }
    },
    data() {
      return {
        constants
      }
    }
  }
</script>

<style scoped>
  .footer {
    flex-shrink: 0;
    background: #fff;
    border-top: 1px solid #e1e6ed;
    padding: 24px;
    width: 100%;
    display: flex;
    justify-content: center;
    gap: 12px;
    position: sticky;
    bottom: 0;
    left: 0;
    z-index: 2;
  }
  .separator {
    display: inline-block;
    width: 2px;
    margin: 0 12px;
  }
  .btn-anexar-arquivos {
    background-color: #28863a;
    color: #fff;
  }
  .btn-anexar-arquivos:disabled,
  .btn-anexar-arquivos[disabled],
  .btn-save:disabled,
  .btn-save[disabled] {
    background: #e0e0e0;
    color: #aaa;
    border: 1px solid #ccc;
    opacity: 0.8;
  }
  @media (max-width: 768px) {
    .footer {
      display: grid;
      grid-template-columns: repeat(2, minmax(0, 1fr));
      gap: 8px;
      padding: 10px 12px;
    }

    .separator {
      display: none;
    }

    .md-button {
      margin: 0 !important;
      min-height: 38px;
      min-width: 0;
      width: 100%;
    }

    .btn-anexar-arquivos,
    .btn-primary,
    .md-raised {
      width: 100%;
    }
  }
</style>
